import * as React from 'react';
const SVGComponent = (props) => (
  <svg
    width={15}
    height={13}
    viewBox='0 0 15 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.30566 0.885406L0.805664 6.13541C0.649414 6.29166 0.555664 6.47916 0.555664 6.69791C0.555664 6.88541 0.649414 7.07291 0.805664 7.22916L6.30566 12.4792C6.58691 12.7604 7.08691 12.7604 7.36816 12.4479C7.64941 12.1667 7.64941 11.6667 7.33691 11.3854L3.18066 7.44791H13.8057C14.2432 7.44791 14.5557 7.10416 14.5557 6.69791C14.5557 6.26041 14.2432 5.94791 13.8057 5.94791H3.18066L7.33691 1.97916C7.64941 1.69791 7.64941 1.19791 7.36816 0.916656C7.08691 0.604156 6.61816 0.604156 6.30566 0.885406Z'
      fill='#74787C'
    />
  </svg>
);
export default SVGComponent;
